module.exports = __webpack_public_path__ + "static/img/wait-deal.773c39cd.png";